import { GetStaticProps } from 'next';
import React, { ReactElement } from 'react';
import WithPage from '../../HOC/Page/WithPage';
import TestScreen from '../../Screens/TestScreen';
import MainLayout from '../../layout/MainLayout';
import { getSiteData } from '../../models/Contentful';
import type { Page } from '../../models/Contentful/types';
import { DefaultPage, IStaticPageProps } from '../../models/Contentful/types';
import { LayoutPage } from '../../types/page';

const TestPage: LayoutPage<IStaticPageProps<DefaultPage>> = () => {
  return (
    <div>
      <div>
        <main>
          <TestScreen />
        </main>
      </div>
    </div>
  );
};

TestPage.getLayout = function getLayout(page: ReactElement, props: IStaticPageProps<DefaultPage>) {
  return <MainLayout {...props}>{page}</MainLayout>;
};

export const getStaticProps: GetStaticProps<IStaticPageProps<DefaultPage>> = async () => {
  const siteData = await getSiteData();

  return { props: { site: siteData.site, page: {} as Page & DefaultPage } };
};

export default WithPage(TestPage, true);
